module.exports = __webpack_public_path__ + "img/gr.567eafea.svg";